/**
 * @generated SignedSource<<42ddaa98035872e98cfc70261b214fae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorLanguageField_language$data = {
  readonly locale: Locale;
  readonly readOnly: boolean;
  readonly " $fragmentType": "EditorLanguageField_language";
};
export type EditorLanguageField_language$key = {
  readonly " $data"?: EditorLanguageField_language$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorLanguageField_language">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorLanguageField_language",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readOnly",
      "storageKey": null
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "acd7f860db60b3f529cfc2190c1afbe1";

export default node;
